import toast from 'react-hot-toast';
import { appNavigate } from './appNavigate';
import { hapticLight } from './haptics';
import { getNotificationOpenPath } from './userNotificationPolicy';

/** App 前景：站內橫幅（鎖屏仍走 FCM，避免與系統通知重複） */
export function showForegroundPushBanner(args: {
  title: string;
  message: string;
  type?: string;
}): void {
  const href = getNotificationOpenPath(args.type ?? '');
  void hapticLight();
  toast(
    (t) => (
      <button
        type="button"
        className="flex flex-col gap-0.5 text-left text-sm"
        onClick={() => {
          toast.dismiss(t.id);
          appNavigate(href);
        }}
      >
        <span className="font-semibold text-slate-900">{args.title}</span>
        <span className="text-xs text-slate-600 line-clamp-2">{args.message}</span>
        <span className="mt-1 text-xs font-medium text-blue-600">點擊查看</span>
      </button>
    ),
    { id: `fg-push-${Date.now()}`, duration: 7000, icon: '🔔' }
  );
}
